module.exports = __webpack_public_path__ + "img/image49.2763638d.jpg";